import React, { useState } from "react";
import { Badge, Card, Button, Form } from "react-bootstrap";
import profilePic from "../../assets/images/profile-avtar.jpg";
import commentAvtar from "../../assets/images/comment-avtar.png";
import { getItem } from "../../utils/Functions";
import { useDispatch, useSelector } from "react-redux";
import { addComment, commentListing } from "../../pages/Agreements/actions";
import { useEffect } from "react";
import moment from "moment";

export const CommentSideBar = ({ closeCommentBar, id }) => {
  const dispatch = useDispatch();
  const [comments, setComments] = useState("");
  const commentList = useSelector((state) => state.agreement.commentList);
  const signingRequestData = useSelector(
    (state) => state.agreement.signingListingData
  );
  const addCommentData = useSelector((state) => state.agreement.addCommentData);
  const offeredCandidateReduxData = useSelector(
    (state) => state.profile.OfferedCandidateProfileDetails.data
  );

  useEffect(() => {
    if (addCommentData && addCommentData.status === 1) {
      dispatch(
        commentListing({
          candidateId: JSON.parse(getItem("User"))._id,
          docId: id,
        })
      );
    }
  }, [addCommentData]);

  const handleAddComment = (e) => {
    e.preventDefault();

    let obj = {
      msg: comments,
      documentId: id,
      candidateId: JSON.parse(getItem("User"))._id,
    };
    dispatch(addComment(obj));
    setComments("");
    closeCommentBar();
  };
  return (
    <>
      <div className="comment-card-sidebar active">
        <Card>
          <button
            className="ms-auto bx bx-x btn btn-light"
            onClick={closeCommentBar}
          ></button>
          <Card.Header>
            <span className="comment-id d-inline-block">
              {signingRequestData && signingRequestData[0].docId}
            </span>
            <Card.Title>
              {signingRequestData && signingRequestData[0].docName}
            </Card.Title>
            {/* <small className="text-muted">Signin Initiation</small> */}
            <div className="d-flex justify-content-between">
              <div>
                <p className="date">
                  {moment(
                    signingRequestData && signingRequestData[0].updatedAt
                  ).format("DD MMM YYYY")}
                </p>
                <small className="time">
                  {moment(
                    signingRequestData && signingRequestData[0].updatedAt
                  ).format("hh:mm A")}
                </small>
              </div>
              <div className="d-flex align-self-center">
                {/* <img src={profilePic} className="me-2" /> */}
                <div class="date">
                  <p className="mb-1">
                    {signingRequestData &&
                      signingRequestData[0].requestedBy?.firstName +
                        " " +
                        signingRequestData[0].requestedBy?.lastName}
                  </p>{" "}
                  {/* <p className="time">Talent Aquisition Manager</p> */}
                </div>
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            {commentList &&
              commentList.data &&
              commentList?.data?.data?.map((item) => {
                return (
                  <>
                    {" "}
                    <div className="comment-box d-flex">
                      <div className="comment-content d-flex">
                        <img src={commentAvtar} className="align-self-start" />
                        <div className="d-block align-self-center">
                          <p>
                            {item && item?.msgBy
                              ? item?.msgBy?.firstName +
                                " " +
                                item?.msgBy?.lastName
                              : offeredCandidateReduxData?.firstName +
                                " " +
                                offeredCandidateReduxData?.lastName}

                            {item && !item.msgBy ? (
                              <Badge variant="success ms-2">You</Badge>
                            ) : (
                              JSON.parse(getItem("User"))._id !==
                                item.msgBy._id && (
                                <Badge variant="primary ms-2">IndiaNic</Badge>
                              )
                            )}
                          </p>
                          <p className="desc ">{item?.msg} </p>
                        </div>
                      </div>
                      <div className="duration">
                        {/* <p className="text-right">12d ago</p> */}
                        <p className="text-right">
                          {moment
                            .utc(item.createdAt)
                            .local()
                            .startOf("seconds")
                            .fromNow()}
                        </p>
                      </div>
                    </div>
                  </>
                );
              })}

            <Form onSubmit={handleAddComment}>
              <Form.Group controlId="formBasicComment" className="mb-3">
                <Form.Label>Add Comment</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                />
              </Form.Group>
              <Button className="theme-btn w-25 ms-auto" type="submit">
                {" "}
                Send{" "}
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};
